import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly THEME_KEY = 'theme';

  constructor(@Inject(DOCUMENT) private document: Document) {}

  initTheme(): void {

    // const storedTheme = localStorage.getItem(this.THEME_KEY);
    // const systemPrefersDark = window.matchMedia(
    //   '(prefers-color-scheme: dark)'
    // ).matches;
    // const theme = (storedTheme === 'dark' || storedTheme === 'light')
    //   ? storedTheme
    //   : (systemPrefersDark ? 'dark' : 'light');
    this.setTheme('dark');
  }

  setTheme(theme: 'light' | 'dark'): void {
    this.document.documentElement.setAttribute('data-theme', theme);
    // localStorage.setItem(this.THEME_KEY, theme);
  }

  toggleTheme(): void {
    const current = this.document.documentElement.getAttribute('data-theme');
    this.setTheme(current === 'dark' ? 'light' : 'dark');
  }

  getCurrentTheme(): 'light' | 'dark' {
    return this.document.documentElement.getAttribute('data-theme') as
      | 'light'
      | 'dark';
  }
}
